<template>
  <div>
    <account-transactions-component :account="account"></account-transactions-component>
  </div>
</template>

<script>
import AccountTransactionsComponent from "@/components/AccountTransactionsComponent";

export default {
  name: "account-transactions",
  mounted() {
    try {
      this.account = Object.assign({}, this.$router.history.current.params.account);
      console.log("CURRENT ACCOUNT IS:", this.account);
      window.scrollTo(0, 0);
    } catch (e) {
      console.log("ERROR:", e);
    }
  },
  data() {
    return {
      account: {},
    };
  },
  methods: {},
  components: {
    AccountTransactionsComponent,
  },
};
</script>

<style lang="scss" scoped></style>
